import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {cloneDeep} from "lodash";
import {addBaseQueryParams, addQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {config} from "@commons/config.instance";
import axios from "axios";
import {DateTime} from "luxon";

export interface PresenzeLavoratoreParams extends Partial<BaseQueryParams> {
    idAziendaMaster: number,
    idAzienda: number,
    idDip: number,
    anno: number,
    mese: number,
    extraInfo: boolean,
    rilevaPianificazione: boolean,
    calcola?: boolean, // se true, la richiesta viene inoltrata al backend JS per il calcolo remoto del periodo indicato
}

export const listLavoratoriPeriodo = (params: PresenzeLavoratoreParams, employeeOrder: boolean = false, user: UserCRUDRecord | null = null) => {
    const orderLavoratori = (lavDaOrdinare: LavoratorePresenzeRecord[] | null, user: UserCRUDRecord | null): LavoratorePresenzeRecord[] => {
        if (!lavDaOrdinare)
            return [];

        if (lavDaOrdinare && user?.userClass === 'EMPLOYEE') {
            let lavoratori: LavoratorePresenzeRecord[] = [];
            lavoratori = lavoratori.concat(cloneDeep(lavDaOrdinare.filter((lav) => lav.codiceFiscale === user?.codiceFiscale)));
            lavoratori = lavoratori.concat(cloneDeep(lavDaOrdinare.filter((lav) => lav.codiceFiscale !== user?.codiceFiscale)));
            return lavoratori;
        } else return lavDaOrdinare;
    };

    const queryParams: string[] = addBaseQueryParams(params);
    //queryParams.push(`anno=${params.anno}`);
    //queryParams.push(`mese=${params.mese}`);
    queryParams.push(`tipologia=0`);
    queryParams.push(`tipologia=1`);
    queryParams.push(`extraInfo=${params.extraInfo ? 'true' : 'false'}`);
    queryParams.push(`rileva-pianificazione=${params.rilevaPianificazione ? 'true' : 'false'}`);
    const url = config.getBaseUrl('FPNet') + `/preSTD/lavoratori/${params.idAziendaMaster}-${params.idAzienda};anno=${params.anno};mese=${params.mese}?${addQueryParams(queryParams)}`
    return axios<LavoratorePresenzeRecord[]>(url).then(res => (employeeOrder ? orderLavoratori(res.data, user) : res.data))
}

export interface LavoratoriParams extends Partial<BaseQueryParams> {
    idAziendaMaster?: number,
    idAzienda?: number,
    forceDataDa: DateTime,
    forceDataA: DateTime,
}

export interface LavoratoreParams extends Partial<BaseQueryParams> {
    idDip: number,
    anno: number,
    mese: number,
}

export const listLavoratoriCoordinati = (params: LavoratoriParams) => {

    const queryParams: string[] = addBaseQueryParams(params);
    //queryParams.push(`anno=${params.anno}`);
    //queryParams.push(`mese=${params.mese}`);
    queryParams.push(`forceDataDa=${params.forceDataDa.toFormat('yyyyLLdd')}`);
    queryParams.push(`forceDataA=${params.forceDataA.toFormat('yyyyLLdd')}`);
    const url = config.getBaseUrl('FPNet') + `/lavoratore/coordinato?${addQueryParams(queryParams)}`
    return axios<LavoratorePresenzeRecord[]>(url).then(res => res.data)
}

export const getLavoratore = (params: LavoratoreParams) => {

    const queryParams: string[] = addBaseQueryParams(params);
    //queryParams.push(`anno=${params.anno}`);
    //queryParams.push(`mese=${params.mese}`);
    queryParams.push(`tipologia=0`);
    queryParams.push(`tipologia=1`);
    const url = config.getBaseUrl('FPNet') + `/preSTD/lavoratore/${params.idDip};anno=${params.anno};mese=${params.mese}?${addQueryParams(queryParams)}`
    return axios<LavoratorePresenzeRecord>(url).then(res => res.data);
}
